import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import FormComponent from "./common/formComponent";
import { getIpV4PoolById, updateIpV4PoolProperty } from "../services/ipv4PoolService";
import PageLoading from "./common/pageLoading";

class IpV4PoolInfo extends FormComponent {
  state = {
    data: {
      _id: "",
      name: "",
      network: "",
      cidr: "",
      subnetMask: "",
      hostCount: "",
      type: "",
      class: ""
    },
    errors: {},
    router: [],
    loading: true,
    processing: false,
  };

  schema = {
    _id: Joi.string().required(),
    name: Joi.string().required().label("Name"),
    network: Joi.string().required().label("Network"),
    cidr: Joi.number().min(0).required().label("CIDR"),
    subnetMask: Joi.string().required().label("Subnet Mask"),
    hostCount: Joi.number().min(1).required().label("Number of Hosts"),
    type: Joi.string().min(0).required().label("Type"),
    class: Joi.string().min(0).required().label("Class"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { _id, name } = this.state.data;
    const property = { name };
    try {
      await updateIpV4PoolProperty(_id, property);
      toast.success("Pool Information Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };


  async populatePoolInfo() {
    const { match } = this.props;
    const poolId = match.params.id;
    try {
      const { data } = await getIpV4PoolById(poolId);
      this.setState({ data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async componentDidMount() {
    await this.populatePoolInfo();
  }

  render() {
    const { data, errors, loading, processing } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && (
          <Form className="mt-4" onSubmit={this.handleSubmit}>
            <Form.Group as={Row} controlId="name">
              <Form.Label column sm={2}>
                Name
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="name" onChange={this.handleChange} value={data.name} size="sm" type="text" />
                {errors.name && <span className="text-danger">{errors.name}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="network">
              <Form.Label column sm={2}>
                Network
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="network" readOnly defaultValue={data.network} />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="cidr">
              <Form.Label column sm={2}>
                CIDR
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="cidr" readOnly defaultValue={data.cidr} />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="type">
              <Form.Label column sm={2}>
                Type
              </Form.Label>
              <Col sm={10}>
                <Form.Control name="type" readOnly defaultValue={data.type} />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={{ span: 10, offset: 2 }}>
                <Button type="submit" disabled={this.validate() || processing}>
                  {processing && (
                    <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                  )}
                  Update
                </Button>
              </Col>
            </Form.Group>
          </Form>
        )}
      </React.Fragment>
    );
  }
}

export default IpV4PoolInfo;
